export const contactList = {
	resumeTitle: 'Resume',
	messageSend: 'Hello, Can you help me?',
	cv: 'joaobru-en.pdf',
};
